(function ($, Drupal) {
  Drupal.behaviors.heimat = {
    attach: function (context, settings) {

      once('replaceSpace', 'body', context).forEach((e) => {
        document.addEventListener("DOMContentLoaded", function () {
          function replacePercentageSpaces(node) {
            const treeWalker = document.createTreeWalker(
              node,
              NodeFilter.SHOW_TEXT,
              {
                acceptNode: function (n) {
                  return /\d+\s%/.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
                }
              },
              false
            );

            while (treeWalker.nextNode()) {
              const currentNode = treeWalker.currentNode;
              currentNode.nodeValue = currentNode.nodeValue.replace(/(\d+)\s%/g, "$1\u00A0%");
            }
          }

          replacePercentageSpaces(document.body);
        });
      });
      
    }
  }
})(jQuery, Drupal);
